import { AssetBulkCreateTabFeature } from "./AssetBulkCreateTabFeature";

export default AssetBulkCreateTabFeature;
